import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: '2rem',
        backgroundColor: 'white',
        borderRadius: '0 0 12px 12px',
        margin: '0 1rem 1rem 1rem',
        minHeight: 200,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        [theme.breakpoints.down('sm')]: {
            padding: '1rem',
            margin: 0,
        },
        [theme.breakpoints.up('sm')]: {
            border: '1px solid #D8D8D8',
        },
    },
}));

const TripFloorplans = () => {
    const classes = useStyles();

    return (
        <Box className={classes.root}>
            <Typography variant="h6" color="textSecondary">
                Floorplans — coming soon
            </Typography>
        </Box>
    );
};

export default TripFloorplans;
